/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Pausereasonid2Inputs */

const en_entity_pausereasonid2 = /** @type {(inputs: Entity_Pausereasonid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause Reason ID`)
};

const de_entity_pausereasonid2 = /** @type {(inputs: Entity_Pausereasonid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

/**
* | output |
* | --- |
* | "Pause Reason ID" |
*
* @param {Entity_Pausereasonid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_pausereasonid2 = /** @type {((inputs?: Entity_Pausereasonid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Pausereasonid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_pausereasonid2(inputs)
	return de_entity_pausereasonid2(inputs)
});
export { entity_pausereasonid2 as "entity_pauseReasonId" }